import styled from 'styled-components';

export const GroupContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
`;

export const RightTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
